import React from 'react';
import { ViolationEdit } from 'modules';
import { URLS } from '_constants';

function EducationViolationEdit() {
  return <ViolationEdit submitUrl={URLS.education} />;
}

export default EducationViolationEdit;
